<template>
  <div class="soil-information-widget">
    <div class="soil-information-title">
      <h2>{{ $t('tableTitles.SoilInfo') }}</h2>
    </div>
    <div class="soil-information-widget-container">
      <soilDataTableOverview
        :enableCreateTableRowAction="enableCreateTableRowAction"
        :enableDeleteTableRowAction="enableDeleteTableRowAction"
        :enableUpdateTableRowAction="enableUpdateTableRowAction"
        :enableColumnChooser="enableColumnChooser"
        :searchPanelEnabled="searchPanelEnabled"
        :enableExportSettings="enableExportSettings"
      />
    </div>
  </div>
</template>
<script>
import soilDataTableOverview from '@/components/table-overviews/soilDataTableOverview'
export default {
  name: 'soilInfoWidget',
  components: {
    soilDataTableOverview
  },
  data() {
    return {
      enableCreateTableRowAction: false,
      enableDeleteTableRowAction: false,
      enableUpdateTableRowAction: false,
      enableColumnChooser: false,
      searchPanelEnabled: false,
      enableExportSettings: false
    }
  }
}
</script>
<style lang="less" scoped>
.soil-information-widget {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  .soil-information-title h2 {
    display: flex;
    justify-content: center;
    margin: 0 0 15px 0;
    font-size: 24px;
    padding-bottom: 15px;
    color: #89b368;
    border-bottom: 1px solid #d5d5d5;
  }
  .soil-information-widget-container {
    display: flex;
    flex-direction: column;
    height: 85%;
    width: 100%;
  }
}
</style>
